import { AutomationValueKind } from '@models/automation-rules';

export enum AutomationFieldKind {
    None = 0,
    Reason = 1,
    Station = 2,
    Fixer = 3,
    SecondaryFixer = 4,
    Directions = 5,
}

export type AutomationFieldType = 'SingleSelect' | 'MultiSelect' | 'FreeText';

export interface AutomationRuleField {
    fieldId: number;
    fieldName: string;
    fieldType: AutomationFieldType;
    fieldKind: AutomationFieldKind;
    /**
     * Discrepancy column the field writes to, `null` when it targets none.
     * Custom column fields are resolved through it, so a new column needs no
     * frontend change.
     */
    targetColumnName: string | null;
    /**
     * What the value of the rules of this field means, so a name based field is
     * matched and written by option name instead of by the option id of a
     * single repository. Fields the api holds no options for have none.
     */
    valueKind?: AutomationValueKind | null;
    value: string;
    /**
     * True when the input stands for "all values": it matches every value of
     * its field, including an empty one and a field the screen does not
     * render. Wildcard inputs carry no value; outputs are never wildcards.
     */
    isWildcard?: boolean;
}

export interface AutomationRule {
    id: number;
    name?: string;
    inputs: AutomationRuleField[];
    outputs: AutomationRuleField[];
}

/**
 * Rules of a single rule type, with the rule type's field sets.
 *
 * The grouping carries the runtime invariants chained evaluation relies on: an
 * output field belongs to exactly one rule type, so the dependency graph
 * (output field -> consuming rule types) is unambiguous, a rule type runs at
 * most once per evaluation and a conflict is only possible inside one of them.
 */
export interface AutomationRuleTypeGroup {
    ruleTypeId: number;
    inputFieldIds: number[];
    outputFieldIds: number[];
    rules: AutomationRule[];
}
